import { useEffect, useRef } from "react";

import { PollingManagerTask } from "~/apps/shared/services/polling-manager";

import { usePollingManager } from "../contexts/polling.context";

export const usePoll = (task: Omit<PollingManagerTask, "timerId">) => {
  const { pollingManager } = usePollingManager();
  const taskRef = useRef(task);

  // Update the ref when task changes
  taskRef.current = task;

  useEffect(() => {
    // Add the task using the ref to ensure we always have latest callback
    pollingManager.add({
      ...taskRef.current,
      callback: () => taskRef.current.callback(),
    });

    return () => {
      pollingManager.remove(task.id);
    };
  }, [pollingManager]); // Only recreate the interval if pollingManager changes
};
